import './Projects.css';
import './../styles/styles.css';
import { Component } from 'react';
import Fade from 'react-reveal/Fade';

import projectsData from '../assets/content/projects.json'

// The description HTML holds a "Brief Description" block followed by a
// "Skills Developed" block. Split on this marker so the project title/subtitle
// can sit between the two, matching the card layout.
const SKILLS_MARKER = '<p><strong>Skills Developed</strong></p>';

class Projects extends Component {
  componentDidMount() {  }

  render () {
    return <div id="projects" className="page-padding-first page-padding-end white-background">
      <Fade bottom>
        <div className="education-title-div">
          <h1 className="title-h1 dark">Projects</h1>
          <p className="title-p light">a few things I've built</p>
        </div>
      </Fade>

      <div className="projects-grid">
        {projectsData.map(el => {
          const idx = el.description.indexOf(SKILLS_MARKER);
          const brief = idx >= 0 ? el.description.slice(0, idx) : el.description;
          const skills = idx >= 0 ? el.description.slice(idx) : '';
          return <Fade bottom key={el.title}>
            <div id={el.id} className="project-card">
              <img className="project-card-image" src={`/images/tiles/${el.tile_path}`} alt={el.title} />
              <div className="project-content">
                <h2 className="project-title dark">{el.title}</h2>
                <h5 className="project-subtitle light">{el.subtitle}</h5>
                {brief && <div className="project-body" dangerouslySetInnerHTML={{ __html: brief }} />}
                {skills && <div className="project-body" dangerouslySetInnerHTML={{ __html: skills }} />}
                {el.link &&
                  <a href={el.link} target="_blank" rel="noreferrer" className="project-link">View Project</a>}
              </div>
            </div>
          </Fade>;
        })}
      </div>
    </div>
  }
}
export default Projects;
